// extracted by mini-css-extract-plugin
export var askAiIcon = "_mq-j";
export var category = "_mq-9";
export var categoryHeader = "_mq-e";
export var container = "_mq-0";
export var group = "_mq-a";
export var groupItems = "_mq-f";
export var groupSeparator = "_mq-k";
export var loading = "_mq-1";
export var noResults = "_mq-3";
export var placeholder = "_mq-2";
export var resultContent = "_mq-5";
export var resultIcon = "_mq-c";
export var resultItem = "_mq-g";
export var resultMeta = "_mq-8";
export var resultSubtitle = "_mq-7";
export var resultSuffix = "_mq-i";
export var resultTitle = "_mq-6";
export var resultsList = "_mq-4";
export var searchGroup = "_mq-d";
export var selected = "_mq-h";
export var subgroup = "_mq-b";